<template>
  <!--订单列表页面-->
  <tk-container
    infiniteScroll
    :status="status"
    ref="productsInfinite"
    @loadingMore="recommendedProducts"
  >
    <template>
      <div style="height: 8px;" v-if="computedOrderList.length"></div>
      <div
        class="m-x-12"
        :class="{'m-t-8': index > 0}"
        v-for="(s, index) in computedOrderList"
        :key="index"
        @click="viewDetail(s, index)"
      >
        <card :height="100" :width="100">
          <tk-flex between middle class="font-14">
            <div class="caption">{{'订单编号：'}}<span :class="{ 'primary': s.copyActive }" @click.stop="copyReviews(s)">{{s.orderId}}</span></div>
            <div class="primary">{{orderStatus(s.status)}}</div>
          </tk-flex>
          <order-commodity-data :order-type="$route.query.type" class="m-t-4" :order-detail="s" :is-show-message="false"></order-commodity-data>
          <!--我的订单按钮-->
          <tk-flex right class="m-t-8"
                   gutter="15"
                   v-if="$route.query.type === 'myOrder'">
            <action-button
              is-border :btn-text="'取消订单'"
              :bd-color="'#999'" :text-color="'#666'"
              :min-width="84" :is-raised="false" is-rounded
              v-if="s.status === 'pendingPayment'"
              @click.native.stop="cancelOrder(s, index)"
            ></action-button>
            <action-button
              is-border :btn-text="'申请退换'"
              :bd-color="'#999'" :text-color="'#666'"
              :min-width="84" :is-raised="false" is-rounded
              v-if="s.status === 'toBeEvaluated' && !s.isApplyReturn"
              @click.native.stop="submitReturn(s, index)"
            ></action-button>
            <action-button
              is-border :btn-text="'取消申请'"
              :bd-color="'#D84342'" :text-color="'#CF1613'"
              :min-width="84" :is-raised="false" is-rounded
              v-if="s.status === 'returnExchange'"
              @click.native.stop="cancelSubmit(s)"
            ></action-button>
            <action-button
              is-border :btn-text="'立即付款'"
              :bd-color="'#D84342'" :text-color="'#CF1613'"
              :min-width="84" :is-raised="false" is-rounded
              v-if="s.status === 'pendingPayment'"
              @click.native.stop="immediatelyPay(s)"
            ></action-button>
            <action-button
              is-border :btn-text="'立即评价'"
              :bd-color="'#D84342'" :text-color="'#CF1613'"
              :min-width="84" :is-raised="false" is-rounded
              v-if="s.status === 'toBeEvaluated'"
              @click.native.stop="immediatelyEvaluated(s)"
            ></action-button>
            <action-button
              is-border :btn-text="'确认收货'"
              :bd-color="'#D84342'" :text-color="'#CF1613'"
              :min-width="84" :is-raised="false" is-rounded
              v-if="s.status === 'pendingReceipt'"
              @click.native.stop="sureReceipt(s)"
            ></action-button>
            <!--<action-button
              is-border :btn-text="'删除订单'"
              :bd-color="'#999'" :text-color="'#666'"
              :min-width="84" :is-raised="false" is-rounded
              v-if="s.status === 'cancelled'"
              @click.native.stop="deleteOrder(s, index)"
            ></action-button>-->
          </tk-flex>
          <!--客户订单按钮-->
          <tk-flex right class="m-t-8" gutter="15" v-else>
            <action-button
              is-border :btn-text="'立即发货'"
              :bd-color="'#D84342'" :text-color="'#CF1613'"
              :min-width="84" :is-raised="false" is-rounded
              v-if="s.status === 'toBeShipped'"
              @click.native.stop="immediatelyShip(s)"
            ></action-button>
            <action-button
              is-border :btn-text="'确定退换'"
              :bd-color="'#D84342'" :text-color="'#CF1613'"
              :min-width="84" :is-raised="false" is-rounded
              v-if="s.status === 'returnExchange'"
              @click.native.stop="sureReturnExchange(s)"
            ></action-button>
          </tk-flex>
        </card>
      </div>
      <tk-spinner v-if="loadStatus" color="#ebebeb" size="14" type="pulse"></tk-spinner>
      <tk-flex center class="p-t-16 p-b-4" v-if="!loadStatus">
        <action-button
          is-border :btn-text="'点击查看更多'"
          :bd-color="'#D84342'" :text-color="'#CF1613'"
          :min-width="84" :is-raised="false" is-rounded
          v-if="isWhetherData"
          @click.native.stop="loadMore"
        ></action-button>
        <div v-else class="caption">没有更多数据</div>
      </tk-flex>
    </template>
    <!--已付款订单发货框-->
    <tk-cover
      :show.sync="isEnterLogistics"
      :hideOnClick="false"
      center
    >
      <card
        :width="70" :height="335"
        class="p-0"
        style="position: relative;"
      >
        <!--关闭弹框-->
        <div class="cover-close" @click="isEnterLogistics = false">
          <tk-icon color="#fff" size="24">delete</tk-icon>
        </div>
        <tk-image :src="logisticsImage" height="60" style="width: 100%;"></tk-image>
        <div class="m-x-20 m-b-10">
          <tkui-simple-input class="logistics-input m-t-20" type="text" v-model="logisticsName" place-holder="物流名称">
          </tkui-simple-input>
          <tkui-simple-input class="logistics-input m-t-20" type="tel" v-model="phone" place-holder="物流电话">
          </tkui-simple-input>
          <tkui-simple-input class="logistics-input m-t-20" type="text" v-model="logisticsNumber" place-holder="物流单号">
          </tkui-simple-input>
          <tkui-simple-input class="logistics-input m-t-20" type="number" v-model="logisticsFreight" place-holder="到付运费">
          </tkui-simple-input>
          <tk-flex center class="m-t-20">
            <tkui-button @click="enterShip" class="small danger raised rounded logistics-btn">提交</tkui-button>
          </tk-flex>
        </div>
      </card>
    </tk-cover>
    <!--支付选择弹框-->
    <tk-cover
      :show.sync="isSelectedPay"
      center
      :hideOnClick="false"
    >
      <tk-card
        :height="50"
        :width="70"
        :is-middle="true"
        style="position: relative;"
      >
        <!--关闭弹框-->
        <div class="cover-close" @click="isSelectedPay = false">
          <tk-icon color="#fff" size="24">delete</tk-icon>
        </div>
        <tk-flex
          between middle
          @click.native="selectedChannel(index)"
          class="font-14 full-width"
          v-for="(s, index) in payList"
          :class="{'m-t-15': index !== 0}"
          :key="index"
        >
          <div>
            <tk-icon size="22">{{s.icon}}</tk-icon>
            <span class="m-l-12">{{s.text}}</span>
          </div>
          <tkui-toggle type="round" v-model="s.isSelected"></tkui-toggle>
        </tk-flex>
        <tk-flex center class="m-t-15 full-width">
          <action-button
            is-border :btn-text="'去支付'"
            :bd-color="'#D84342'" :text-color="'#CF1613'"
            :min-width="180" :is-raised="false" is-rounded
            @click.native="payOrder"
          ></action-button>
        </tk-flex>
      </tk-card>
    </tk-cover>
    <!--确认收货弹框-->
    <tkui-dialog :show.sync="isShowReceipt" center>
      <div class="subhead">
        您确定要确认收货吗？
      </div>
      <template slot="action">
        <button class="tkui-dialog-button" @click="isShowReceipt = false">取消</button>
        <button class="tkui-dialog-button primary" @click="immediatelyReceipt(s)">确定</button>
      </template>
    </tkui-dialog>
    <!--为你推荐-->
    <infinite-list v-if="!loadStatus" :infinite-list-pad="'p-x-12'" :title="'为你推荐'" :products-data="getPriceProcessing(recommendedProductsData, judgeTimeRule)" :color="'#000000'"></infinite-list>
  </tk-container>
</template>

<script>
import orderCommodityData from '@/components/orderCommodityData'
import { priceProcessing, payMoney, getJobOrder } from '@/assets/help/tool'
const logisticsImage = 'https://s3.moke.cloud/dianpei/8d0e0928-56fe-4f5a-ab0b-4dc5e2642579.png'
const copy = require('clipboard-copy')
export default {
  components: {
    orderCommodityData
  },
  data () {
    return {
      status: false, // 页面状态
      orderList: [], // 订单数据
      timeRule: {}, // 限时抢购时间规则
      recommendedProductsData: [], // 为你推荐商品数据获取
      pageCount: 10, // 每次加载条数
      currentCount: 1, // 记录点击的页数
      copyActive: false, // 复制单号状态
      isWhetherData: false, // 是否还有数据
      loadStatus: false, // 数据加载状态
      settlementDisabled: false, // 支付状态
      logisticsImage: logisticsImage, // 物流输入框图片
      isEnterLogistics: false, // 物流输入框状态
      isSelectedPay: false, // 是否选择支付
      isShowReceipt: false, // 是否确认收货
      selectedReceipt: null, // 选中要收货的订单
      selectedShip: null, // 选中要发货的数据
      selectedPayOrder: null, // 选中的要付款的订单
      logisticsName: '', // 物流名称
      phone: '', // 物流电话
      logisticsNumber: '', // 物流单号
      logisticsFreight: '', // 物流运费
      payChannel: 'ALI_APP', // 选定的支付通道
      payList: [ // 支付方式
        {
          icon: 'alipay',
          text: '支付宝',
          payChannel: 'ALI_APP',
          isSelected: true
        }, {
          icon: 'wechat',
          text: '微信',
          payChannel: 'WX_APP',
          isSelected: false
        }
      ]
    }
  },
  props: {
    orderType: {
      type: String,
      default: 'all'
    },
    orderEdit: { // 动态修改的数据
      type: null
    },
    orderMiddle: { // action后的中间值
      type: null
    }
  },
  computed: {
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    },
    // 修改列表数据显示orderEdit
    computedOrderList () {
      if (!this.orderList.length) { return [] }
      if (!this.orderEdit && !this.orderMiddle) { return this.orderList }
      let orderList = this.$tkHelper.deepClone(this.orderList)
      if (this.orderEdit && this.orderEdit.id && this.orderEdit.status) { // 详情页处理后的列表变化
        let index = orderList.findIndex(s => { return s.objectId === this.orderEdit.id })
        if (index !== -1) { orderList[index].status = this.orderEdit.status }
      }
      if (this.orderMiddle) { // 列表页操作后的列表变化
        if (this.orderMiddle.status) {
          let index = orderList.findIndex(s => { return s.objectId === this.orderMiddle.id })
          if (index !== -1) { orderList[index].status = this.orderMiddle.status }
        } else {
          let index = orderList.findIndex(s => { return s.objectId === this.orderMiddle.id })
          if (index !== -1) { orderList.splice(index, 1) }
        }
      }
      return orderList
    }
  },
  beforeMount () {
    this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
    if (!this.$route.query.list) {
      this.getOrderList()
    }
  },
  methods: {
    /**
    * 复制订单编号
    * @date: 2020/10/27
    */
    copyReviews (s) {
      s.copyActive = true
      copy(s.orderId).then(e => {
        this.$tkGlobal.toast.add('订单编号已复制')
      }).catch(e => {
        s.copyActive = false
        this.$tkGlobal.toast.add('订单编号复制失败')
      })
      this.$forceUpdate()
    },
    /**
     * 获取订单列表
     * @date: 2020/5/
     */
    async getOrderList () {
      let obj = {}
      this.loadStatus = true
      if (this.$route.query.type === 'myOrder') { // 我的订单获取条件
        obj.buyUser = this.userInfo.objectId
        if (this.orderType !== 'all') { obj.status = this.orderType }
      } else { // 客户订单获取条件
        obj.merchants = this.userInfo.objectId
        if (this.orderType !== 'all') { obj.status = this.orderType }
      }
      let res = await this.$tkParse.getList('/classes/order', {
        params: {
          limit: this.pageCount,
          skip: (this.currentCount - 1) * this.pageCount,
          order: '-createdAt',
          include: ['buyUser', 'merchants'],
          where: obj
        }
      })
      let dataCount = await this.statisticsNum('order', obj)
      if (res.length <= this.pageCount) {
        this.loadStatus = false
      }
      if (res.length) {
        this.orderList.forEach(s => { s.copyActive = false })
      }
      this.orderList = [...this.orderList, ...res]
      this.isWhetherData = this.orderList.length < dataCount
    },
    /**
     * @Description: 加载更多数据
     * @author xiaozan
     * @date 2020/5/3
     */
    async loadMore () {
      this.currentCount = this.currentCount + 1
      await this.getOrderList()
    },
    /**
    * 重新加载
    * @date: 2020/10/27
    */
    async refreshInitA () {
      this.orderList = []
      this.pageCount = 10
      this.currentCount = 0
      // this.recommendedProductsData = []
      await this.loadMore()
      // this.$refs.productsInfinite.resetInfiniteScroll()
      this.$forceUpdate()
    },
    /**
    * 方法替换filters
    * @date: 2020/6/5
    */
    orderStatus (val) {
      if (!val) return ''
      if (val === 'cancelled') { return '已取消' }
      if (val === 'completed') { return this.$route.query.type !== 'myOrder' ? '已评价' : '已完成' }
      if (val === 'toBeShipped') { return '待发货' }
      if (val === 'toBeEvaluated') { return '待评价' }
      if (val === 'pendingPayment') { return '待付款' }
      if (val === 'pendingReceipt') { return this.$route.query.type !== 'myOrder' ? '已发货' : '待收货' }
      if (val === 'returnExchange') { return '退换货' }
    },
    /**
    * 查看订单详情
    * @date: 2020/5/13
    */
    async viewDetail (s, index) {
      let judgeOrder = await this.judgeId(s.objectId, 'order')
      if (!judgeOrder) {
        this.orderList.splice(index, 1)
        return this.$tkGlobal.toast.add('该订单不存在')
      }
      this.$push({ path: '/common/orderDetail',
        query: { id: s.objectId, type: this.$route.query.type } })
    },
    /**
     * @Description: 删除订单
     * @author xiaozan
     * @date 2020/5/5
     */
    async deleteOrder (s, index) {
      this.status = 'waiting'
      let judgeOrder = await this.judgeId(s.objectId, 'order')
      if (!judgeOrder) {
        this.orderList.splice(index, 1)
        this.status = false
        return this.$tkGlobal.toast.add('该订单不存在')
      }
      this.orderList.splice(index, 1)
      await this.$tkParse.delete(`/classes/order/${s.objectId}`).catch(s => {
        throw this.$tkGlobal.toast.add('删除订单失败')
      })
      await this.$tkHelper.sleep(500)
      this.$store.commit('setOrderMiddleValue', { id: s.objectId, status: null, type: this.$route.query.type })
      this.status = false
      this.$tkGlobal.toast.add('删除成功')
    },
    /**
     * @Description: 我的订单 取消订单
     * @author xiaozan
     * @date 2020/5/4
     */
    async cancelOrder (s, index) {
      let sum = await this.statisticsNum('order', { status: 'cancelled', objectId: s.objectId })
      let judgeOrder = await this.judgeId(s.objectId, 'order')
      if ((sum > 0 && judgeOrder) || !judgeOrder) {
        this.orderList[index].status = 'cancelled'
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('订单已经取消过了')
      }
      this.status = 'waiting'
      await this.$cloudAjax.post('/orderActions/$cancelOrder', {
        orderId: s.objectId,
        userId: this.userInfo.objectId
      }).catch(e => {
        this.status = false
        throw this.$tkGlobal.toast.add(e.data ? e.data : '订单取消失败，如有需要请联系客服')
      })
      this.orderList[index].status = 'cancelled'
      this.$store.commit('setOrderMiddleValue', { id: s.objectId, status: 'cancelled', type: this.$route.query.type })
      this.$tkGlobal.toast.add('订单取消成功')
      this.$forceUpdate()
      this.status = false
    },
    /**
     * @Description: 我的订单 申请退换
     * @author xiaozan
     * @date 2020/5/4
     */
    async submitReturn (s, index) {
      let sum = await this.statisticsNum('returnExchangeRecords',
        { order: s.objectId, user: s.buyUser.objectId })
      if (sum > 0) {
        this.orderList[index].status = 'returnExchange'
        s.isApplyReturn = true
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('请勿重复提交')
      }
      this.$push({ path: '/order/applyReturn', query: { id: s.objectId } })
    },
    /**
     * @Description: 我的订单 取消申请
     * @author xiaozan
     * @date 2020/5/4
     */
    async cancelSubmit (s) {
      let sum = await this.statisticsNum('returnExchangeRecords',
        { user: s.buyUser.objectId, order: s.objectId })
      if (sum === 0) {
        s.status = 'toBeEvaluated'
        s.isApplyReturn = false
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('请勿重复取消')
      }
      let submitSum = await this.statisticsNum('returnExchangeRecords',
        { user: s.buyUser.objectId, order: s.objectId, status: { $ne: 'submitted' } })
      if (submitSum > 0) {
        s.status = 'toBeEvaluated'
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('退换货申请状态已改变')
      }
      let res = await this.$tkParse.getList('/classes/returnExchangeRecords', {
        params: {
          limit: 1,
          where: {
            user: s.buyUser.objectId,
            order: s.objectId
          }
        }
      })
      await this.$tkParse.delete(`/classes/returnExchangeRecords/${res[0].objectId}`)
      await this.$tkParse.put(`/classes/order/${s.objectId}`, {
        status: 'toBeEvaluated',
        isApplyReturn: false
      })
      s.status = 'toBeEvaluated'
      s.isApplyReturn = false
      this.$store.commit('setOrderMiddleValue', { id: s.objectId, status: 'toBeEvaluated', type: this.$route.query.type })
      this.$tkGlobal.toast.add('您成功取消了退换货申请')
    },
    /**
     * @Description: 付款
     * @author xiaozan
     * @date 2020/5/5
     */
    async payOrder () {
      this.isSelectedPay = false
      this.status = 'waiting'
      this.$tkHistory.disable()
      if (this.settlementDisabled) { return }
      // 准备给云接口传参数 userId, selectedProductsData, merchants, discountOrderAmount, payChannel, orderId
      let orderObj = {
        userId: this.userInfo.objectId, // 用户的id
        selectedProductsData: [this.selectedPayOrder], // 选定要结算的数据
        merchants: this.selectedPayOrder.merchants.objectId, // 商户id
        discountOrderAmount: this.selectedPayOrder.orderAmount, // 结算的金额
        orderId: this.selectedPayOrder.objectId, // 结算的订单id
        payChannel: 'WX_APP' // 选定的支付方式
      }
      // 支付订单
      let payStatus = await payMoney(this.selectedPayOrder.objectId, this.selectedPayOrder.orderAmount, 'WX_APP')
      if (!payStatus) {
        this.status = false
        this.$tkHistory.enable()
        this.settlementDisabled = false
        this.$tkGlobal.toast.add('付款失败')
        return
      }
      // 支付成功以后·修改待付款订单为已付款·修改商品销量 如果为限时抢购商品减库存· 跳转支付成功页面
      if (orderObj.discountOrderAmount === 0) {
        orderObj.trade_success = true
        await this.$cloudAjax.post('/wxpay/$payOrder', orderObj).catch(e => {
          this.status = false
          this.$tkHistory.enable()
          this.settlementDisabled = false
          throw this.$tkGlobal.toast.add(e.data ? e.data : '生成订单失败')
        })
      }
      let index = this.orderList.findIndex(m => { return m.objectId === this.selectedPayOrder.objectId })
      if (index !== -1) {
        this.orderList[index].status = 'toBeShipped'
      }
      this.$tkGlobal.toast.add('付款成功')
      this.$push({ path: '/order/paySuccess', query: { id: this.selectedPayOrder.objectId } })
      await this.$tkHelper.sleep(500)
      this.status = false
      this.$tkHistory.enable()
      this.settlementDisabled = false
    },
    /**
     * 选定支付方式
     * @date: 2020/4/28
     */
    async selectedChannel (index) {
      this.payList.forEach(s => { s.isSelected = false })
      this.payList[index].isSelected = true
      this.payChannel = this.payList[index].payChannel
    },
    /**
     * @Description: 我的订单 立即付款
     * @author xiaozan
     * @date 2020/5/4
     */
    immediatelyPay (s) {
      // this.isSelectedPay = true
      this.selectedPayOrder = s
      this.payOrder()
    },
    /**
     * @Description: 我的订单 立即评价
     * @author xiaozan
     * @date 2020/5/4
     */
    async immediatelyEvaluated (s) {
      let sum = await this.statisticsNum('order',
        { status: 'completed', objectId: s.objectId })
      if (sum > 0) {
        s.status = 'completed'
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('该订单已经评价了')
      }
      this.$push({ path: '/order/toEvaluatedPage', query: { id: s.objectId } })
    },
    /**
    * 确定收货
    * @date: 2020/6/5
    */
    async sureReceipt (s) {
      let sum = await this.statisticsNum('order', { status: 'toBeEvaluated', objectId: s.objectId })
      if (sum > 0) {
        s.status = 'toBeEvaluated'
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('该订单已经收过货了')
      }
      this.isShowReceipt = true
      this.selectedReceipt = s
    },
    /**
     * @Description: 我的订单 确定收货
     * @author xiaozan
     * @date 2020/5/4
     */
    async immediatelyReceipt () {
      let s = this.selectedReceipt
      let sum = await this.statisticsNum('order', { status: 'toBeEvaluated', objectId: s.objectId })
      if (sum > 0) {
        s.status = 'toBeEvaluated'
        this.$forceUpdate()
        this.isShowReceipt = false
        return this.$tkGlobal.toast.add('该订单已经收过货了')
      }
      // 删除任务列表中对应任务
      let res = await getJobOrder('sureReceipt', s.objectId)
      if (res.length) {
        // schedule[res[0].objectId].cancel()
        await this.$tkParse.delete(`/classes/scheduleJob/${res[0].objectId}`)
      }
      // 确认收货
      await this.$tkParse.put(`/classes/order/${s.objectId}`, {
        status: 'toBeEvaluated'
      }).catch(e => {
        throw this.$tkGlobal.toast.add('收货失败')
      })
      let index = this.orderList.findIndex(m => { return m.objectId === s.objectId })
      if (index !== -1) {
        this.orderList[index].status = 'toBeEvaluated'
      }
      this.$store.commit('setOrderMiddleValue', { id: s.objectId, status: 'toBeEvaluated', type: this.$route.query.type })
      this.$tkGlobal.toast.add('确认收货提交成功')
      this.isShowReceipt = false
    },
    /**
     * @Description: 客户订单 立即发货
     * @author xiaozan
     * @date 2020/5/4
     */
    async immediatelyShip (s) {
      let sum = await this.statisticsNum('order', { status: 'pendingReceipt', objectId: s.objectId })
      if (sum > 0) {
        s.status = 'pendingReceipt'
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('该订单已经发过货了')
      }
      this.selectedShip = s
      this.isEnterLogistics = true
    },
    /**
     * @Description: 客户订单 确定退换
     * @author xiaozan
     * @date 2020/5/4
     */
    async sureReturnExchange (s) {
      let sum = await this.statisticsNum('returnExchangeRecords',
        { user: s.buyUser.objectId, order: s.objectId })
      if (sum === 0) {
        s.status = 'toBeEvaluated'
        s.isApplyReturn = false
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('用户申请已取消')
      }
      let submitSum = await this.statisticsNum('returnExchangeRecords',
        { user: s.buyUser.objectId, order: s.objectId, status: { $ne: 'submitted' } })
      if (submitSum > 0) {
        s.status = 'toBeEvaluated'
        this.$forceUpdate()
        return this.$tkGlobal.toast.add('您已经确定退换了')
      }
      let res = await this.$tkParse.getList('/classes/returnExchangeRecords', {
        params: {
          limit: 1,
          where: { user: s.buyUser.objectId, order: s.objectId }
        }
      })
      await this.$tkParse.put(`/classes/returnExchangeRecords/${res[0].objectId}`, {
        status: 'approved'
      })
      await this.$tkParse.put(`/classes/order/${s.objectId}`, {
        status: 'toBeEvaluated'
      })
      s.status = 'toBeEvaluated'
      this.$store.commit('setOrderMiddleValue', { id: s.objectId, status: 'toBeEvaluated', type: this.$route.query.type })
      this.$tkGlobal.toast.add('您同意了用户的退换货申请')
    },
    /**
     * @Description: 发货
     * @author xiaozan
     * @date 2020/5/3
     */
    async enterShip () {
      if (!this.logisticsName || !this.phone || !this.logisticsNumber || !this.logisticsFreight) {
        return this.$tkGlobal.toast.add('发货信息不完整')
      }
      let orderObj = {
        logisticsName: this.logisticsName, // 物流名称
        phone: this.phone, // 物流电话
        logisticsNumber: this.logisticsNumber, // 物流单号
        logisticsFreight: Number(this.logisticsFreight), // 物流运费
        userId: this.userInfo.objectId, // 用户的id
        selectedShip: this.selectedShip // 选择发货的订单
      }
      await this.$cloudAjax.post('/orderActions/$enterShip', orderObj).catch(e => {
        this.selectedShip = null
        throw this.$tkGlobal.toast.add(e.data ? e.data : '发货失败')
      })
      let index = this.orderList.findIndex(m => { return m.objectId === this.selectedShip.objectId })
      if (index !== -1) {
        this.orderList[index].status = 'pendingReceipt'
      }
      this.$tkGlobal.toast.add('发货信息提交成功')
      this.$store.commit('setOrderMiddleValue', { id: this.selectedShip.objectId, status: 'pendingReceipt', type: this.$route.query.type })
      this.selectedShip = null
      this.isEnterLogistics = false
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/3/20
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let timeRule = await this.$tkParse.getList(`/classes/timeRule`, {
        params: {
          limit: 1,
          where: {
            startTime: {
              $lte: {
                '__type': 'Date',
                'iso': isoStartDate
              }
            }
          }
        }
      })
      if (timeRule.length) { this.timeRule = timeRule[0] } else { this.timeRule = null }
    },
    /**
     * 工具转换
     * @date: 2020/4/10
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    },
    /**
     * 为你推荐数据获取
     * @date: 2020/3/24
     */
    async recommendedProducts (page, next) {
      let commodityData = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-sales',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      this.recommendedProductsData = [...this.recommendedProductsData, ...commodityData]
      if (commodityData.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    }
  }
}
</script>

<style scoped lang="scss">
  /*图片样式*/
  .commodity-style-image {
    width: 85px;
    height: 85px;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    .commodity-style-image-invalid {
      position: absolute;
      bottom: 0;
      left: 0;
      border-radius: 5px;
      text-align: center;
      color: #fff;
      line-height: 30px;
      width: 100%;
      height: 30px;
      background: #6d8796;
    }
  }
  /*买家留言样式*/
  .msg-input {
    ::placeholder {
      font-size: 12px;
      color: rgba(153, 153, 153, 1);
    }
  }
  /*发货框样式*/
  .cover-close {
    position: absolute;
    top: -60px;
    z-index: 1;
    right: 0;
  }
  .logistics-input {
    width: 100%;
    height: 40px;
    background-color: rgba(245, 245, 245, 1);
    border-radius: 20px;
    padding-left: 10px;
  }
  .logistics-input::placeholder  {
    font-size: 13px;
    color: rgba(153, 153, 153, 1);
  }
  .logistics-btn {
    margin: 0 auto;
    width: 115px;
    height: 32px;
    border-radius: 16px;
    background: #F7B43B !important;
  }
</style>
